module.exports = __webpack_public_path__ + "img/HQMH3196.b1f8cd6d.jpeg";